import { render } from "./App.vue?vue&type=template&id=152c35d5"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=152c35d5&lang=scss"

import exportComponent from "E:\\SonPhat\\Project\\BanVe\\TraCuuVe_FE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__